import type { User } from '@/lib/types'

// Bind to the server-issued ID after provisioning. Never authorize by display name.
export const pearDemoOrganizationId = process.env.REACT_APP_PEAR_DEMO_ORGANIZATION_ID?.trim() || ''
export const pearDemoDefinition = { name: 'Pear Demo', workflow: 'Demo', route: '/clinic-operations/demo' } as const

export function canAccessClinicDemo(user: Pick<User, 'is_active' | 'is_superuser' | 'organizations'> | null, organizationId = pearDemoOrganizationId): boolean {
 if (!user?.is_active) return false
 if (user.is_superuser) return true
 return !!organizationId && user.organizations.some(org => org.id === organizationId && ['admin', 'user', 'staff'].includes(org.role))
}
